import { Box, Typography } from '@mui/material'

export default function ListingDescriptionFrame() {
  // Calculate first day of next month
  const getFirstDayOfNextMonth = () => {
    const now = new Date();
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    return nextMonth.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      {/* iPhone Frame */}
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Listing Description Content */}
        <Box sx={{ p: 2, height: '100%', overflow: 'hidden' }}>
          {/* Property Image */}
          <Box
            sx={{
              height: 140,
              backgroundImage: 'url(https://prod-listing-photos-heyyproperty.s3.us-east-1.amazonaws.com/listings/21a5f509-0dba-4564-bf3f-ddcdf24093ce/0.JPG)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              borderRadius: 2,
              mb: 2,
              position: 'relative'
            }}
          >
          </Box>

          {/* Description Preview */}
          <Box sx={{
            fontSize: '0.75rem',
            lineHeight: 1.4,
            color: 'grey.700',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflow: 'hidden',
            height: 'calc(100% - 200px)'
          }}>
            <Box sx={{
              bgcolor: '#fef3c7',
              px: 0.5,
              py: 0.25,
              borderRadius: 0.5,
              display: 'inline',
              fontWeight: 600,
              color: '#92400e',
              fontSize: '0.825rem'
            }}>
              Catchy hooks, get more bites 🎣
            </Box>
            {'\n'}
            You don't wanna miss this one 👀! Welcome to your future home in a vibrant neighborhood of Baltimore!
            {'\n\n'}
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <Box sx={{
                bgcolor: '#fef3c7',
                px: 0.5,
                py: 0.25,
                borderRadius: 0.5,
                display: 'inline',
                fontWeight: 600,
                color: '#92400e',
                fontSize: '0.825rem'
              }}>
                Your screening & tour scheduling system!
              </Box>
            </Box>
            {'\n'}
            <b>Book a tour here: 👇🏿 app.heyyproperty.com/schedule-tour/Bmore</b>
            {'\n'}
            {'\n'}
            <Box sx={{ position: 'relative', display: 'inline-block' }}>
              <Box sx={{
                bgcolor: '#fef3c7',
                px: 0.5,
                py: 0.25,
                borderRadius: 0.5,
                display: 'inline',
                fontWeight: 600,
                color: '#92400e',
                fontSize: '0.825rem'
              }}>
                Make it pop 💦 
              </Box>
            </Box>
            {'\n'}
            🛏️ 4 Spacious Bedrooms
            {'\n'}
            🛁 3 Convenient Bathrooms
            {'\n'}
            🧺 In-Unit Laundry for Your Comfort
            {'\n\n'}
            <Box sx={{
              bgcolor: '#fef3c7',
              px: 0.5,
              py: 0.25,
              borderRadius: 0.5,
              display: 'inline',
              fontWeight: 600,
              color: '#92400e',
              fontSize: '0.825rem'
            }}>
              Stand out! Pull in local gems.
            </Box>
            {'\n'}
            - 5 min walk to Patterson Park 🌳
            {'\n'}
            - 10 min walk to OneDo Coffee Roasters ☕
            {'\n'}
            - 5 min drive to Safeway 🛒
            {'\n'}
            <Box sx={{
              bgcolor: '#fef3c7',
              px: 0.5,
              py: 0.25,
              borderRadius: 0.5,
              display: 'inline',
              fontWeight: 600,
              color: '#92400e',
              fontSize: '0.825rem'
            }}>
              Lay out your rules.
            </Box>
            {'\n'}
            - Available starting {getFirstDayOfNextMonth()}
          </Box>
        </Box>

        {/* Home Indicator */}
        <Box sx={{
          position: 'absolute',
          bottom: 8,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 134,
          height: 5,
          bgcolor: '#000',
          borderRadius: 3
        }} />
      </Box>
    </Box>
  )
}
